module.exports = __webpack_public_path__ + "static/media/kronn-logo.f3c530f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/kronn-logo.svg
// module id = 272
// module chunks = 0